import { render } from "./MessageCard.vue?vue&type=template&id=6d25c48c&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"

import "./MessageCard.vue?vue&type=style&index=0&id=6d25c48c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d25c48c"]])

export default __exports__